"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import Image from "next/image";
import { ImageIcon } from "lucide-react";
import { blurPlaceholders } from "./blur-placeholders";
export function ImageSlot(t0) {
  const $ = _c(23);
  const {
    className: t1,
    id,
    priority: t2,
    prompt,
    src
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const priority = t2 === undefined ? false : t2;
  const [errored, setErrored] = useState(false);
  if (src && !errored) {
    const placeholder = blurPlaceholders[id];
    const t3 = `relative overflow-hidden ${className}`;
    const t4 = priority ? "eager" : "lazy";
    const t5 = placeholder ? "blur" : "empty";
    let t6;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = () => setErrored(true);
      $[0] = t6;
    } else {
      t6 = $[0];
    }
    let t7;
    if ($[1] !== placeholder || $[2] !== priority || $[3] !== prompt || $[4] !== src || $[5] !== t4 || $[6] !== t5) {
      t7 = <Image src={src} alt={prompt} fill={true} sizes="(max-width: 768px) 100vw, (max-width: 1200px) 80vw, 1200px" className="object-cover" loading={t4} priority={priority} placeholder={t5} blurDataURL={placeholder} onError={t6} draggable={false} />;
      $[1] = placeholder;
      $[2] = priority;
      $[3] = prompt;
      $[4] = src;
      $[5] = t4;
      $[6] = t5;
      $[7] = t7;
    } else {
      t7 = $[7];
    }
    let t8;
    if ($[8] !== t3 || $[9] !== t7) {
      t8 = <div className={t3}>{t7}</div>;
      $[8] = t3;
      $[9] = t7;
      $[10] = t8;
    } else {
      t8 = $[10];
    }
    return t8;
  }
  const t3 = `flex flex-col items-center justify-center gap-3 rounded-2xl border-2 border-dashed border-slate-200 bg-slate-50/50 p-6 ${className}`;
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex size-12 items-center justify-center rounded-xl bg-slate-100"><ImageIcon className="size-5 text-slate-500" /></div>;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== id) {
    t5 = <p className="text-[10px] font-medium text-slate-500 uppercase">#{id}</p>;
    $[12] = id;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== prompt) {
    t6 = <p className="mt-1 text-xs leading-relaxed text-slate-500">{prompt}</p>;
    $[14] = prompt;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t5 || $[17] !== t6) {
    t7 = <div className="max-w-xs text-center">{t5}{t6}</div>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== prompt || $[20] !== t3 || $[21] !== t7) {
    t8 = <div className={t3} title={prompt}>{t4}{t7}</div>;
    $[19] = prompt;
    $[20] = t3;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}